import { Box, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import SortByList from '../../../../components/PageHelpers/Sort'
import TitleWithCountV2 from '../../../../components/PageHelpers/TitleWithCountV2'
import UsersList from '../../../../images/UsersList.svg'
import IconBtnV2 from '../../../../components/Buttons/IconBtnV2'
import FilterSort from '../../../../images/FilterSort.svg'
import SearchBarToggle from '../../../../components/PageHelpers/SearchBarToggle'
import UseTranslation from '../../../../hooks/UseTranslation'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn'
import SummariesBtn from '../../../../components/PageHelpers/SummariesBtn'
import ActiveFiltersWithKey from '../../../../components/PageHelpers/ActiveFiltersWithKey'
import OfoqMultiAutoComplete from '../../../../components/Forms/OfoqMultiAutoComplete'
import AppRoutes from '../../../../services/AppRoutes'
import {
  filterSystemAdminUsers,
  retrieveSystemAdminUsers,
} from '../../../../redux/features/users/SystemAdminUsers/SystemAdminUsersThunk'
import { selectSystemAdminUsers } from '../../../../redux/features/users/SystemAdminUsers/SystemAdminUsersSlice'
import OfoqAutoComplete from '../../../../components/Forms/OfoqAutoComplete'
import { normalizeToArray } from '../../../../utils/helpers'

const Mobile = () => {
  const systemAdminUsers = useSelector(selectSystemAdminUsers)
  const [openFilter, setOpenFilter] = useState(false)
  const { t } = UseTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const handleNavigation = () => {
    history.push(`${baseUri}${AppRoutes.adduser}`)
  }
  const handleClose = () => {
    dispatch(filterSystemAdminUsers({ queries: 'clear' }))
    setOpenFilter(false)
  }
  const [searchBarExpanded, setSearchBarExpanded] = useState(false)
  const [selectedUserTypes, setSelectedUserTypes] =
    useState(systemAdminUsers?.activeFilters?.userTypes || [])
  const [selectedCompanies, setSelectedCompanies] =
    useState(systemAdminUsers?.activeFilters?.companies || [])
  const [subscriptionReminder, setSubscriptionReminder] = useState(
    () => normalizeToArray(systemAdminUsers?.activeFilters?.subscriptionReminder),
  )
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  useEffect(() => {
    if (systemAdminUsers?.activeFilters?.userTypes?.length !== selectedUserTypes.length) {
      setSelectedUserTypes(systemAdminUsers?.activeFilters?.userTypes || [])
    }
    if (systemAdminUsers?.activeFilters?.companies?.length !== selectedCompanies.length) {
      setSelectedCompanies(systemAdminUsers?.activeFilters?.companies || [])
    }
    const nextReminder = normalizeToArray(
      systemAdminUsers?.activeFilters?.subscriptionReminder,
    )
    if (nextReminder.length !== subscriptionReminder.length) {
      setSubscriptionReminder(nextReminder)
    }
  }, [systemAdminUsers?.activeFilters])

  useEffect(() => {
    if (!openFilter) return

    dispatch(filterSystemAdminUsers({
      queries: {
        userTypes: selectedUserTypes,
        companies: selectedCompanies,
        subscriptionReminder,
      },
    }))
  }, [selectedUserTypes, selectedCompanies, subscriptionReminder])

  const isFilteredArraysNotEmpty =
    systemAdminUsers?.activeFilters?.userTypes?.length > 0 ||
    systemAdminUsers?.activeFilters?.companies?.length > 0 ||
    systemAdminUsers?.activeFilters?.subscriptionReminder?.length > 0

  return (
    <Box sx={styles.employeeContainer}>
      <Box sx={styles.firstRow}>
        {!searchBarExpanded && (
          <TitleWithCountV2
            icon={<img src={UsersList} alt="UsersList" />}
                iconSize='xl'
            store={systemAdminUsers}
            title={t?.Users}
            customCount={t?.Users}
            withCount
            customStyle={styles.titleHeader}
          />
        )}
        <Box sx={styles.searchSortFilter}>
          <Box sx={isXsScreen && styles.filterWithSearch}>
            {(isXsScreen && !searchBarExpanded) && (
              <IconBtnV2
                icon={openFilter ? <CloseIcon /> : <img src={FilterSort} alt="filter icon" />}
                onClick={() => setOpenFilter(!openFilter)}
                customStyle={styles.xsFilterButton(isFilteredArraysNotEmpty)}
              />
            )}
            <SearchBarToggle
              actionToDispatch={retrieveSystemAdminUsers}
              searchPlaceholder={t?.['Search for user by username, Company or E-mail address']}
              expandedState={searchBarExpanded}
              setExpandedState={setSearchBarExpanded}
              customStyle={styles.searchBar(searchBarExpanded)}
              actionProps={{ pageNumber: 0 }}
              sendQueryAsObject
            />
          </Box>
        </Box>
      </Box>
      <OfoqThemeBtn name={t?.['Add Customer User']} onClick={handleNavigation} customStyle={styles.addCustomerUserBtn} />
      <SummariesBtn
        actionToDispatch={retrieveSystemAdminUsers}
        store={systemAdminUsers}
        sendQueryAsObject
        customStyle={styles.summaryBtn}
      />
      <FormModalContainer
        modalTitle={t?.['Filter By']}
        modalState={openFilter}
        handleClose={() => setOpenFilter(false)}
        customWidth={styles.filterForm}
        keepMounted
        formModalStyle
        mobileModalStyle
        cancelText={t?.Close}
      >
        <Box sx={styles.filterBox}>
          {isFilteredArraysNotEmpty && (
          <ActiveFiltersWithKey
            title={t?.['Applied Filters']}
            store={systemAdminUsers}
            actionToDispatch={filterSystemAdminUsers}
            filterSortModalStyle
          />
          )}
          <SortByList
            actionToDispatch={retrieveSystemAdminUsers}
            store={systemAdminUsers}
            customStyle={styles.sortBy}
            sendQueryAsObject
            actionProps={{ pageNumber: 0 }}
          />
          <OfoqMultiAutoComplete
            name={t?.['User Type']}
            store={systemAdminUsers?.filterList?.userTypes}
            defaultOption={selectedUserTypes}
            refState={setSelectedUserTypes}
            customStyle={styles.firstFilter}
            key={`User Type -${openFilter}`}
          />
          <OfoqMultiAutoComplete
            name={t?.Company}
            store={systemAdminUsers?.filterList?.companies}
            defaultOption={selectedCompanies}
            refState={setSelectedCompanies}
            customStyle={styles.firstFilter}
            key={`Company -${openFilter}`}
          />
          <OfoqAutoComplete
            name={t?.['Reminder Message']}
            optionsConfig={systemAdminUsers?.filterList?.subscriptionReminder}
            defaultOption={subscriptionReminder[0] ?? null}
            refState={(selected) => setSubscriptionReminder(normalizeToArray(selected))}
            customStyle={styles.subscriptionReminderFilter}
          />
        </Box>
        <OfoqThemeBtn
          name={`${t?.['Clear Filters']}`}
          disabled={!isFilteredArraysNotEmpty}
          onClick={handleClose}
          customStyle={styles.clearFilters}
        />
      </FormModalContainer>
    </Box>
  )
}

const styles = {
  employeeContainer: {
    display: { xs: 'flex', sm: 'none' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    p: '10px 5px',
  },
  firstRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: { xs: '5px', sm: '10px' },
    '& img': {
      paddingRight: '5px',
    },
    '& span': {
      fontFamily: 'Avenir 85 light',
      fontWeight: 400,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '37.08px' },
    },
    '& p': {
      margin: '0',
    },
  },
  searchSortFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  searchBar: (isFiltered) => ({
    height: '35px',
    width: isFiltered ? '100%' : '35px',
    marginBottom: { xs: '10px', sm: '0px' },
  }),
  sortFilter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px',
  },
  filterWithSearch: {
    display: 'flex',
    gap: '5px',
    width: '100%',
    justifyContent: 'flex-end',
    '& img': {
      width: '20px',
      height: '20px',
    },
  },
  xsFilterButton: (isFiltered) => ({
    height: '35px',
    width: '35px',
    borderRadius: '10px',
    border: isFiltered ? '1px solid #29CC8B' : '1px solid #e2e8ee',
    backgroundColor: isFiltered ? 'white' : 'none',
    color: 'text.hint',
    overflow: 'hidden',
    '& img': {
      filter: isFiltered && 'brightness(0) saturate(100%) invert(60%) sepia(98%) saturate(331%) hue-rotate(90deg) brightness(91%) contrast(91%)',
    },
  }),
  activeFilter: {
    marginBottom: { xs: '10px', sm: '5px' },
    marginTop: { xs: '5px', sm: '0px' },
  },
  sortBy: {
    margin: { xs: 0, sm: '0 15px' },
    '& p': {
      fontSize: { xs: '12px', sm: '16px' },
    },
    '& button': {
      fontSize: { xs: '12px', sm: '16px' },
    },
  },
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
  },
  firstFilter: {
    margin: { xs: '5px 0', sm: '0 10px' },
  },
  sideButton: {
    width: '100%',
    textAlign: 'center',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px',
    margin: '1px -15px',
    marginLeft: '-15px',
    paddingTop: '8px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
  },
  option: {
    color: '#000000',
    textTransform: 'capitalize',
    minWidth: { xs: 'max-content', sm: '130px' },
    fontSize: { xs: '10px', sm: '16px' },
    margin: { xs: '0', sm: '5px 0' },
    padding: '0px',
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '5px', sm: '7px' },
      width: { xs: '25px', sm: 'unset' },
      height: { xs: '25px', sm: 'unset' },
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '11px', sm: '16px' },
    },
  },
  customCheckStyle: {
    width: '100%',
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  clearFilters: {
    marginInline: '0px !important',
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    height: { xs: '40px', sm: 'unset' },
    marginTop: '10px',
  },
  summaryBtn: {
    marginTop: '10px',
    '& button': {
      fontWeight: 'bold',
    },
  },
  addCustomerUserBtn: {
    maxWidth: { xs: '100%', sm: '150px' },
    marginInline: { xs: '0px', sm: '10px' },
  },
  subscriptionReminderFilter: {
    marginInline: { xs: '0px', md: '10px' },
    marginBottom: '10px',
    '& label::before': {
      content: "'🔔'",
      fontSize: '11px',
      marginRight: 1,
    },
  },
}

export default Mobile
